var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProduction(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 36,
    viewBox: "0 0 51 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 8.5C11.6716 8.5 11 9.17157 11 10C11 10.8284 11.6716 11.5 12.5 11.5V8.5ZM15 11.5H16.5V8.5H15V11.5ZM12.5 11.5H15V8.5H12.5V11.5Z",
    fill: "#737373"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5 13.7C4.17157 13.7 3.5 14.3716 3.5 15.2C3.5 16.0284 4.17157 16.7 5 16.7V13.7ZM15 16.7H16.5V13.7H15V16.7ZM5 16.7H15V13.7H5V16.7Z",
    fill: "#737373"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 18.9C1.67157 18.9 1 19.5716 1 20.4C1 21.2285 1.67157 21.9 2.5 21.9V18.9ZM15 21.9H16.5V18.9H15V21.9ZM2.5 21.9H15V18.9H2.5V21.9Z",
    fill: "#737373"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5 24.1C4.17157 24.1 3.5 24.7715 3.5 25.6C3.5 26.4284 4.17157 27.1 5 27.1V24.1ZM15 27.1H16.5V24.1H15V27.1ZM5 27.1H15V24.1H5V27.1Z",
    fill: "#737373"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 29.3C6.67157 29.3 6 29.9716 6 30.8C6 31.6284 6.67157 32.3 7.5 32.3V29.3ZM15 32.3H16.5V29.3H15V32.3ZM7.5 32.3H15V29.3H7.5V32.3Z",
    fill: "#737373"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M50 2.63643V4.99122C50 5.15998 49.939 5.32193 49.8303 5.44126C49.7217 5.56059 49.5743 5.62764 49.4207 5.62764H18.5793C18.2594 5.62764 18 5.34295 18 4.99122V2.63643C18 2.28497 18.2594 2 18.5793 2H49.4207C49.5743 2 49.7217 2.06705 49.8303 2.18638C49.939 2.30599 50 2.46766 50 2.63643ZM18.9381 7.53693H49.0612V33.3636C49.0612 33.5323 49.0002 33.694 48.8916 33.8136C48.783 33.9329 48.6355 34 48.4819 34H19.5174C19.1975 34 18.9381 33.715 18.9381 33.3636V7.53693ZM28.9191 12.6284C28.9191 13.1349 29.1022 13.6205 29.4281 13.9785C29.7542 14.3365 30.1962 14.5376 30.657 14.5376H37.3536C37.9742 14.5376 38.5481 14.1739 38.8584 13.583C39.169 12.9923 39.169 12.2647 38.8584 11.6737C38.5481 11.083 37.9742 10.719 37.3536 10.719H30.645C30.1842 10.719 29.7422 10.9202 29.4164 11.2785C29.0902 11.6365 28.9072 12.122 28.9072 12.6284L28.9191 12.6284Z",
    fill: "#737373"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProduction);
export default __webpack_public_path__ + "static/media/Production.c8f87b01f84a00ac07305e52b7564a77.svg";
export { ForwardRef as ReactComponent };